import React from 'react'
import './CrossClientRolloutIllustration.scss'
import illustration from '../../../assets/images/cross-client-onboarding-illustration.png'

export const CrossClientRolloutIllustration: React.FC = () => {
  return <img src={illustration} alt='' aria-hidden='true' className='cross-client-rollout-illustration' />
}
